export const MIN_GUEST_COUNT = 2;
export const MAX_GUEST_COUNT = 500;
export const DIGITS_ONLY_PATTERN = /^[0-9]+$/;

export const GUEST_COUNT_MIN_ERROR_MESSAGE = `Enter a number greater than ${MIN_GUEST_COUNT - 1}.`;
export const GUEST_COUNT_MAX_ERROR_MESSAGE = `Maximum guest count for this estimate is ${MAX_GUEST_COUNT}.`;

export const getGuestCountError = (val: string): string | undefined => {
	const num = Number(val);
	return !val || !DIGITS_ONLY_PATTERN.test(val) || num < MIN_GUEST_COUNT
		? GUEST_COUNT_MIN_ERROR_MESSAGE
		: num > MAX_GUEST_COUNT
			? GUEST_COUNT_MAX_ERROR_MESSAGE
			: undefined;
};
